import React from 'react';
import { makeStyles } from 'tss-react/mui';
import {
  DropdownMenuSeparatorProps,
  Separator,
} from '@radix-ui/react-dropdown-menu';
import palette from '@ui/palette';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()(theme => ({
  separator: {
    backgroundColor: palette.gray_600,
    height: 1,
    margin: 5,
  },
}));

interface MenuSeparatorProps extends DropdownMenuSeparatorProps {}

const MenuSeparator = (props: MenuSeparatorProps) => {
  const { className, ...rest } = props;
  const { classes, cx } = useStyles();
  return <Separator className={cx(classes.separator, className)} {...rest} />;
};

export default MenuSeparator;
